import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Breadcrumb, Button, Form, Header, Search, Segment } from "semantic-ui-react";
import { INVITE_USER, FIND_USERS, ADMIN_GET_SUBSCRIPTION } from "../../GraphQL";
import { useMutation, useLazyQuery } from "@apollo/client";
import debounce from "lodash/debounce";

const UserSearchSection = () => {
  const [getUsers, { loading, data }] = useLazyQuery(FIND_USERS);

  const debouncedGetUsers = debounce((e, { value }) => {
    getUsers({
      variables: { filter: value.trim() },
      fetchPolicy: "network-only",
    });
  }, 1000);
  return (
    <Segment basic>
      <Header as="h3">
        User Search
        <Header.Subheader>
          Search by email address, Stripe Customer ID, or User ID
        </Header.Subheader>
      </Header>
      <Search
        id="user-search"
        loading={loading}
        placeholder="janedoe@gmail.com"
        onSearchChange={debouncedGetUsers}
        results={
          data && data.users
            ? data.users.map(({ name, email, sub }) => ({
                as: "a",
                target: "_blank",
                href: `/admin/users/${sub}`,
                title: name,
                description: email,
                id: sub,
              }))
            : []
        }
      />
    </Segment>
  );
};

const SubscriptionSearchSection = () => {
  const [getSubscription, { loading, data }] = useLazyQuery(
    ADMIN_GET_SUBSCRIPTION
  );

  const debouncedGetSubscription = debounce((e, { value }) => {
    getSubscription({
      variables: { id: value.trim() },
      fetchPolicy: "network-only",
    });
  }, 1000);
  return (
    <Segment basic>
      <Header as="h3">
        Subscription Search
        <Header.Subheader>Search by Subscription ID</Header.Subheader>
      </Header>
      <Search
        id="subscription-search"
        loading={loading}
        placeholder="sub_XXX"
        onSearchChange={debouncedGetSubscription}
        results={
          data && data.subscription
            ? [
                {
                  as: "a",
                  target: "_blank",
                  href: `/admin/subscriptions/${data.subscription.id}`,
                  title: data.subscription.id,
                  id: data.subscription.id,
                },
              ]
            : []
        }
      />
    </Segment>
  );
};

const NewSubscriptionSection = () => {
  return (
    <Segment basic>
      <Header as="h3">New Subscription</Header>
      <Button as={Link} to="/admin/subscriptions/new">
          Create New Subscription
      </Button>
    </Segment>
  );
};


const UserInvitationSection = () => {
  const [inviteUser, { loading }] = useMutation(INVITE_USER);
  const [email, setEmail] = useState("");
  const [subscriptionId, setSubscriptionId] = useState("");

  return (
    <Segment basic>
      <Form
        onSubmit={() => {
          inviteUser({
            variables: {
              group: "Teachers",
              email,
              subscription: subscriptionId,
            },
            inviteUser,
          });
        }}
      >
        <Header as="h3">Invite User</Header>
        <Form.Input
          label="Email Address"
          value={email}
          placeholder="janedoe@gmail.com"
          onChange={(e, { value }) => setEmail(value)}
        />
        <Form.Input
          label="Stripe Subscription ID (optional)"
          value={subscriptionId}
          placeholder="sub_XXXXX"
          onChange={(e, { value }) => setSubscriptionId(value)}
        />
        <Form.Button loading={loading} disabled={!email}>
          Invite
        </Form.Button>
      </Form>
    </Segment>
  );
};

const AdminHome = () => {
  return (
    <div>
      <Breadcrumb size="tiny">
        <Breadcrumb.Section>
          <Link to="/admin">Admin Home</Link>
        </Breadcrumb.Section>
      </Breadcrumb>
      <UserSearchSection />
      <SubscriptionSearchSection />
      <UserInvitationSection />
      <NewSubscriptionSection />
    </div>
  );
};

export default AdminHome;
